import React, { useEffect, useState } from 'react'
import Sidebar from '../../Components/Sidebar'
import TopHeader from '../../Components/TopHeader'
import BannerPage from '../../Components/Banner'
import { useAboutUsStore } from '../../store/useAboutUs'
import Story from './Story'
import Ourpromise from './Ourpromise'
import Mission from './Mission'
import Founder from './Founder'

const About = () => {

    const { getAbout } = useAboutUsStore()
    const [loading, setLoading] = useState(false)

    const getAboutUsFunction = async () => {
        setLoading(true)
        await getAbout()
        setLoading(false)
    }

    useEffect(() => {
        getAboutUsFunction()
    }, [])
    return (
        <div id="admin-dashboard" className="flex h-[800px] bg-neutral-100">
            <Sidebar />
            <div id="main-content" className="flex-1 flex flex-col overflow-hidden">
                <TopHeader pageName="About Us" />
                <div id="content-container" className="flex-1 overflow-auto p-6">
                    <BannerPage pageName={'aboutUs'} />
                    {/* Code here */}
                    <Story />
                    <Ourpromise />
                    <Mission />
                    <Founder />
                </div>
            </div>
        </div>
    )
}

export default About
